export default __webpack_public_path__ + "static/award_4-2114b88f8660522275f0f2003c3e0052.svg";